<form *ngIf="costCenterFormGroup" [formGroup]="costCenterFormGroup">
  <div class="grid">
    
    <div class="col input-field">
      <label for="code">Código</label>
      <input pInputText name="code" formControlName="code" d-form-field-error />
  </div>
      <div class="col input-field">
          <label for="name">Nombre</label>
          <input pInputText name="name" formControlName="name" d-form-field-error />
      </div>
      <div class="col input-field">
        <label for="default">Por defecto</label>
        <p-inputSwitch id="default" formControlName="default" d-form-field-error />
    </div>
  </div>
  <div class="mt-4 flex gap-2">
      <p-button label="Eliminar" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()" *ngIf="costCenter.id && allowDelete"></p-button>
      <div class="flex-grow"></div>
      <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
      <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-save"  (click)="save()"></p-button>
  </div>
</form>